import { ZAW_PAGE_NAMES } from 'helpers/zaw';
import { FEATURE_ENABLED_VARIANT_NAME_TREATMENT } from 'constants/features';
import { checkIsHomepage } from 'history/historyFactory';

const phase1List = [
  '/c/customer-service',
  '/c/about',
  '/c/adaptive',
  '/c/associates-program',
  '/c/contact-us',
  '/c/content-usage-terms',
  '/c/customer-reviews',
  '/c/privacy-policy',
  '/c/shipping-and-delivery-questions',
  '/c/shipping-and-returns',
  '/c/terms-of-use',
  '/c/vip-faqs',
  '/c/vip-terms-and-conditions',
  '/c/zappos-for-good-faq',
  '/c/zappos-gift-cards',
  '/c/zappos-insights',
  '/c/zaw-amazon-faq',
  '/c/zaw-returns'
];

const p2List = [
  '/c/outdoor',
  '/c/ugg',
  '/c/crocs',
  '/c/coupon',
  '/c/return-trans-options',
  '/c/hoka-shoes',
  '/c/new-balance-001',
  '/c/on',
  '/c/brands'
].concat(phase1List);
const doNotRedirectList = ['/c/e-gift-cards', '/c/vip-dash', '/c/account-deletion-request', ...ZAW_PAGE_NAMES];

function isInATreatment(variation: string) {
  return ['treatment', 'phase2', 'phase3'].includes(variation);
}
export const redirectLandingPageToKratos = ({
  currentPath,
  multivariateExperimentVariation,
  search
}: {
  currentPath: string;
  // treatment is phase 1 since we didn't plan ahead
  multivariateExperimentVariation: 'control' | 'treatment' | 'phase2' | 'phase3';
  search?: URLSearchParams;
}) => {
  if (
    isInATreatment(multivariateExperimentVariation) &&
    ((multivariateExperimentVariation === FEATURE_ENABLED_VARIANT_NAME_TREATMENT && phase1List.includes(currentPath)) ||
      (multivariateExperimentVariation === 'phase2' && p2List.includes(currentPath)) ||
      (multivariateExperimentVariation === 'phase3' && !doNotRedirectList.includes(currentPath) && !checkIsHomepage(currentPath)))
  ) {
    // URLSearchParams has a size field but it's relatively recent so need a different way to determine if there are any parameters
    const queryString = search ? search.toString() : '';
    const redirectPath = queryString ? `/kratos${currentPath}?${queryString}` : `/kratos${currentPath}`;
    return {
      isRedirected: true,
      redirectPath
    };
  }

  return {
    isRedirected: false
  };
};
